/* eslint-disable max-params */

import { objectToQueryString } from "../utils/helpers/checkout-util";

// eslint-disable-next-line max-statements
export default (api) => {
    const getVASBundles = ({ token, year, price, experiment, tag, orderId }) => {
        let url = `/api/v1/landing-page?carYear=${year}&carPrice=${price}&orderId=${orderId}`;
        if (experiment) {
            url = `/api/v1/landing-page?carYear=${year}&carPrice=${price}&experiment=${experiment}&tag=${tag}&orderId=${orderId}`;
        }
        return api.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const getVASBundlesV2 = ({ token, year, price, experiment, tag, orderId }) => {
        let url = `/api/v2/landing-page?carYear=${year}&carPrice=${price}`;
        if (experiment) {
            url = `/api/v2/landing-page?carYear=${year}&carPrice=${price}&experiment=${experiment}&tag=${tag}&orderId=${orderId}`;
        }
        return api.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const getVASItems = ({ token, key = "VAS_POPULAR_BUNDLES", year, price, experiment, tag, orderId }) => {
        let url = `/api/v1/vas-store?key=${key}&carYear=${year}&carPrice=${price}&orderId=${orderId}`;
        if (experiment && tag) {
            url = `/api/v1/vas-store?key=${key}&carYear=${year}&carPrice=${price}&experiment=${experiment}&tag=${tag}&orderId=${orderId}`;
        }
        return api.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const validateServicingPriceExperiment = ({ token, appointmentId, pincode, servicingPricingExperiment = "TESTING" }) => {
        return api.get(`/api/v1/validate-experiment/${servicingPricingExperiment}?appointmentId=${appointmentId}&pincode=${pincode}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const getCarCoverBundle = ({ token, appointmentId, servicingPricingExperiment = "OLD", tradeIn = false, orderId, tag, metadataKey }) => {
        const queryString = objectToQueryString({ tag, tradeIn, orderId, experiment: servicingPricingExperiment, appointmentId, metadataKey });
        return api.get(`api/v1/car-cover-page?${queryString}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const addVASItem = ({ token, orderId, type, key, year, price, vasPageName, source, updateQuote = false }) => {
        const queryString = objectToQueryString({ carYear: year, carPrice: price, vasPageName, ...(source ? { source } : {}), updateQuote });
        let url = `/api/v1/vas/add-item/${orderId}/${type}/${key}`;
        if (queryString) {
            url += `?${queryString}`;
        }
        return api.post(url, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    };

    const removeVASItem = ({ token, orderId, type, key, year, price, vasPageName, source, updateQuote = false }) => {
        const queryString = objectToQueryString({ carYear: year, carPrice: price, vasPageName, ...(source ? { source } : {}), updateQuote });
        let url = `/api/v1/vas/remove-item/${orderId}/${type}/${key}`;
        if (queryString) {
            url += `?${queryString}`;
        }
        return api.put(url, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    };

    const getVASCart = ({ token, orderId, year, price, vasPageName }) => {
        const queryString = objectToQueryString({ carYear: year, carPrice: price, vasPageName });
        let url = `/api/v1/vas/${orderId}`;
        if (queryString) {
            url += `?${queryString}`;
        }
        return api.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const clearVASCart = ({ token, orderId, year, price, vasPageName }) => {
        const queryString = objectToQueryString({ carYear: year, carPrice: price, vasPageName });
        let url = `/api/v1/vas/clear/${orderId}`;
        if (queryString) {
            url += `?${queryString}`;
        }
        return api.put(url, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    };

    const vasTracker = (token, orderId, action) => {
        return api.put(`/api/v1/vas-tracker?orderId=${orderId}&action=${action}`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    };

    const getVASProductDetail = ({ token, key, carYear, type, carPrice }) => {
        return api.get(`/api/v1/detail-page?key=${key}&carYear=${carYear}&type=${type}&carPrice=${carPrice}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const getWarrantyPlans = (token, params = "") => {
        return api.get(`/v1/extended-warranty/plans${params}`, {
            headers: {
                ...(token && { Authorization: `Bearer ${token}` }),
                X_VEHICLE_TYPE: "CAR"
            }
        });
    };

    const getPostBcLandingPlans = ({ token, appointmentId, tradeIn = false, orderId }) => {
        return api.get(`api/v1/post-bc/landing-page?tradeIn=${tradeIn}&orderId=${orderId}&appointmentId=${appointmentId}&source=POST_BC`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const postBcUpdateStep = ({ token, orderId, key, appointmentId, action }) => {
        const url = `/api/v1/vas-journey/step`;
        const request = {
            orderId,
            appointmentId,
            action,
            step: key
        };
        return api.put(url, request, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    };

    const getInsuranceDetails = ({token, orderId}) => {
        return api.get(`/api/v1/insurance/details?orderId=${orderId}`, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const submitInsuranceDetails = ({token, orderId, payload, triggerHuddle = false, triggerForm = false}) => {
        return api.post(`/api/v1/insurance/process/${orderId}?triggerHuddle=${triggerHuddle}&triggerForm=${triggerForm}`, payload, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        });
    };

    const getMetaData = (token, key = "", appointmentId = "", type = "PRODUCT") => {
        return api.get(`api/v1/car-cover/metadata?key=${key}&appointmentId=${appointmentId}&type=${type}`, {
            headers: {
                ...(token && { Authorization: `Bearer ${token}` }),
                X_VEHICLE_TYPE: "CAR"
            }
        });
    };

    const getPreBcPagePitching = ({ token, orderId, pageType }) => {
        const url = `/api/v1/order/${orderId}/pre-bc/page-pitching?pageType=${pageType}`;
        return api.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });

    };

    const updateVASOfferGift = ({ token, orderId, itemKey, itemType, vasPageName, discount = 0.0, active = true }) => {
        const url = `/api/v1/vas/offer/order/${orderId}`;
        const request = {
            itemKey,
            itemType,
            vasPageName,
            discount,
            active
        };
        return api.post(url, request, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    };

    return {
        getVASBundles,
        getVASItems,
        getVASCart,
        addVASItem,
        removeVASItem,
        clearVASCart,
        vasTracker,
        getVASProductDetail,
        getWarrantyPlans,
        validateServicingPriceExperiment,
        getCarCoverBundle,
        getPostBcLandingPlans,
        postBcUpdateStep,
        getVASBundlesV2,
        getInsuranceDetails,
        submitInsuranceDetails,
        getMetaData,
        getPreBcPagePitching,
        updateVASOfferGift
    };
};
